import type { UserRole } from "@/types";

/**
 * Application permissions mapped to roles
 */
export const PERMISSIONS = {
  "users:manage": ["ADMIN"],
  "tenants:manage": ["ADMIN"],
  "managers:manage": ["ADMIN"],
  "castings:manage": ["ADMIN", "MODERATOR"],
  "linkhub:manage": ["ADMIN", "MANAGER"],
  "rooms:manage": ["ADMIN"],
  "calendar:manage": ["ADMIN", "MANAGER"],
} as const satisfies Record<string, readonly UserRole[]>;

export type Permission = keyof typeof PERMISSIONS;

export const USER_ROLES: readonly UserRole[] = [
  "ADMIN",
  "MODERATOR",
  "MANAGER",
] as const;
